import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { masterFailReasonMessage } from '../../../smartLinks/catalog/song/masterFailReason';
import { MasterDownloadButton } from '../../../smartLinks/catalog/song/player/MasterDownloadButton';
import { catalogSongFieldMessages } from './catalogSongFieldMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the song files; each part uses its own slice of it */
import styles from '../../../smartLinks/catalog/song/SongFiles.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongMasterFailedLineProps {
  accountId: number;
  item: CatalogItem;
}

/**
 * A master that Music24 cannot read: the reason, and Download, so that the artist can check the file
 * (design o1b). The fix is on the song page in Catalog.
 */
const SongMasterFailedLineComponent: React.FC<SongMasterFailedLineProps> = ({ accountId, item }) => {
  const intl = useIntl();
  const message = masterFailReasonMessage(item.song.masterFailReason) ?? catalogSongFieldMessages.masterFailed;
  return (
    <div className="d-flex align-items-center gap-3">
      <span className={`${styles.error} flex-grow-1`}>
        {withBrandWord(intl.formatMessage(message, { title: item.title }))}
      </span>
      <MasterDownloadButton accountId={accountId} itemUuid={item.uuid} fileName={item.title} />
    </div>
  );
};

export const SongMasterFailedLine = TypedMemo(SongMasterFailedLineComponent);
